export default __webpack_public_path__ + "static/media/Messages-icon.2b137495.svg";